import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setLeaseRate, setLeaseRateUnits } from 'bundles/apex/deals/form/store/deal/actions';

import DealField from 'bundles/apex/deals/form/fields/field';
import WithUnits from 'bundles/apex/deals/form/fields/with_units';
import { calculatesLeaseRate } from 'bundles/apex/deals/lease_terms/helpers';
import { leaseRateUnitOptions } from 'components/lease_structure/form/helpers/select_options';

export function LeaseRate({ deal, invalid, setLeaseRate, setLeaseRateUnits, ...props }) {
  return (
    <WithUnits
      {...props}
      deal={deal}
      disabled={calculatesLeaseRate(deal)}
      invalid={invalid}
      type="currency"
      unitOptions={leaseRateUnitOptions({ spaceSizeUnits: deal.spaceSizeUnits })}
      onUnitsChange={setLeaseRateUnits}
      onValueChange={setLeaseRate}
    />
  );
}

LeaseRate.propTypes = {
  deal: PropTypes.shape({
    spaceSizeUnits: PropTypes.string,
  }).isRequired,
  invalid: PropTypes.bool,
  setLeaseRate: PropTypes.func.isRequired,
  setLeaseRateUnits: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setLeaseRate,
  setLeaseRateUnits,
};

export default connect(null, mapDispatchToProps)(DealField(LeaseRate, 'leaseRate'));
